import { render, staticRenderFns } from "./CoozzyEditIconImg.vue?vue&type=template&id=6d4d3140&scoped=true"
import script from "./CoozzyEditIconImg.vue?vue&type=script&lang=js"
export * from "./CoozzyEditIconImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d3140",
  null
  
)

export default component.exports